
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose, lifecycle } from 'recompose'
import { translate } from 'react-switch-lang'

import MyController from '../../core/components/MyController'
import ViewFAQ from '../../views/global/ViewFAQ'

import SettingManager from '../../business/SettingManager'

class FAQController extends MyController {
	constructor(props) {
		super(props)
		this.state.isLoading = false
		this.bSetting = new SettingManager(this)
	}

	onGetFAQ = () => {
		return this.bSetting.getFAQ()
	}

	render() {
		return (
			<React.Fragment>
				{super.render()}
				<ViewFAQ
					onGetFAQ={this.onGetFAQ}
				/>
			</React.Fragment>
		)
	}
}

const enhance = compose(
	translate,
	withRouter,
	connect(
		(state, props) => ({

		}),
		(dispatch, props) => ({

		}),
	),
	lifecycle({
		componentDidMount() {
		}
	})
)


export default enhance(FAQController)